// import { NotificationAdd, Notifications } from "@mui/icons-material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const HomeHero = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");

  const setSortParams = (sortType: string) => {
    const sortParams = new URLSearchParams({
      sort: sortType,
    });
    return sortParams.toString();
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      navigate(`/property-search/${searchText}`);
    }
  };
  return (
    <div className="flex flex-col">
      <div className="bg-custom-gradient2 p-[24px] flex items-start gap-16 lg:items-center justify-between">
        {/* On small screens it becomes a clickable link */}
        <a
          href="https://example.com" // <-- put your actual link here
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 sm:hidden"
        >
          <img src="/assets/images/flag-new.svg" alt="" />
          <span className="font-poppins underline text-primary">
            Officially commissioned by the President of the Federal Republic of
            Nigeria
          </span>
        </a>

        {/* On medium and larger screens it stays plain text */}
        <div className="flex items-center gap-2 hidden sm:flex">
          <img src="/assets/images/flag-new.svg" alt="" />
          <span className="font-poppins">
            Officially commissioned by the President of the Federal Republic of
            Nigeria
          </span>
        </div>

        <a
          href="https://guardian.ng/news/nigeria/national/nidcom-sydani-firstbank-launch-home-and-abroad-platform-to-empower-diaspora-nigerians"
          rel="noopener noreferrer"
          target="_blank"
          className="text-primary lg:block hidden  font-poppins"
        >
          View announcement
        </a>
      </div>
      <div
        className="w-full min-h-[658px] h-full shadow-custom bg-[#333333BF]/50 bg-blend-overlay bg-cover bg-center flex items-center" // note the flex and items-center
        style={{ backgroundImage: "url('/assets/images/hero_imgn1.webp')" }}
      >
        <div className="max-w-[719px] p-6 lg:p-0 lg:ml-[72px] flex flex-col gap-10 w-full">
          <h2 className="font-poppins font-semibold text-[28px] md:text-[32px] lg:text-[42px] leading-[44px] md:leading-[48px] lg:leading-[52px] tracking-[0%] capitalize text-textWhite">
            Buy Nigerian properties securely from anywhere in the  world
          </h2>
          <div className="flex flex-col gap-[30px]">
            {/* <div className="flex space-x-3 items-start text-primary font-semibold">
              <Link to={`/property-search?${setSortParams("Popularity")}`}>
                <button className="bg-white w-28 px-[15px] py-[10px] rounded-lg">
                  Hot
                </button>
              </Link>
              <Link to={`/property-search?${setSortParams("Newest Listings")}`}>
                <button className="bg-white px-[15px] py-[10px] rounded-lg">
                  Recently Listed
                </button>
              </Link>
              <Link to="/property-search">
                <button className="bg-white px-[15px] py-[10px] rounded-lg">
                  Just Sold
                </button>
              </Link>
            </div> */}
            <div className="flex space-x-3 items-start text-primary font-semibold w-full">
              <Link
                to={`/property-search?${setSortParams("Price: High-end")}`}
                className="flex-1 md:flex-none"
              >
                <button className="bg-white w-full md:w-auto px-[15px] py-[10px] rounded-lg">
                  High-end
                </button>
              </Link>
              <Link
                to={`/property-search?${setSortParams("Price: Affordable")}`}
                className="flex-1 md:flex-none"
              >
                <button className="bg-white w-full md:w-auto px-[15px] py-[10px] rounded-lg">
                  Affordable
                </button>
              </Link>
              <Link
                to={`/property-search?${setSortParams("Newest Listings")}`}
                className="flex-1 md:flex-none"
              >
                <button className="bg-white text-nowrap w-full md:w-auto px-[15px] py-[10px] rounded-lg">
                  Recently Listed
                </button>
              </Link>
            </div>
            <div className="rounded-full md:rounded-[20px] relative flex justify-between bg-white w-full sm:w-[689px] md:py-2">
              <input
                type="text"
                value={searchText}
                onKeyDown={handleKeyDown}
                onChange={handleInputChange}
                className="h-full w-full py-[16px] md:py-[18px] focus:outline-none px-6 rounded-[20px] sm:text-[16px] text-textGrey"
                placeholder="Address, City, or Neighborhood"
              />
              <div
                onClick={() => navigate(`/property-search/${searchText}`)}
                className="absolute cursor-pointer h-full right-6 top-0 flex items-center justify-center"
              >
                <img
                  src="/assets/images/search.svg"
                  className="w-7 md:w-8"
                  alt=""
                />
              </div>
            </div>
            {/* <div className="bg-textWhite flex flex-col lg:flex-row rounded-lg p-5 gap-1.5 lg:gap-3 w-full">
              <div className="w-full lg:w-[90%] flex gap-3">
                <div className="w-1/2 lg:w-1/3 flex flex-col gap-3.5">
                  <span className="text-textBlack4 font-poppins font-medium">
                    Location
                  </span>
                  <div className="flex items-center p-3.5 border border-[#CECECE] gap-3 bg-textWhite border rounded-lg">
                    <img src="/assets/images/location-n.svg" alt="" />
                    <input
                      type="text"
                      placeholder="City, state, or neighborhood"
                      className="bg-transparent outline-none text-[#CECECE] text-base w-full"
                    />
                  </div>
                </div>
                <div className="hidden w-auto lg:w-1/3 lg:flex flex-col gap-3.5">
                  <span className="text-textBlack4 font-poppins font-medium">
                    Price Range
                  </span>
                  <div className="flex items-center p-3.5 border border-[#CECECE] gap-3 bg-textWhite border rounded-lg">
                    <img src="/assets/images/naira-sign.svg" alt="" />
                    <input
                      type="text"
                      placeholder="Price range"
                      className="bg-transparent outline-none text-[#CECECE] text-base w-full"
                    />
                  </div>
                </div>
                <div className="w-1/2 lg:w-1/3 flex flex-col gap-3.5">
                  <span className="text-textBlack4 font-poppins font-medium">
                    Property Type
                  </span>
                  <SelectProperty setProperty={setProperty} />
                </div>
              </div>
              <div className="w-full lg:w-[19%] lg:flex flex-col gap-3.5">
                <div className="text-white font-poppins font-medium">.</div>
                <button className="h-[43px] w-full hover:cursor-pointer hover:bg-primary/70 transition duration-300 bg-primary rounded-lg text-textWhite flex items-center justify-center shadow-custom gap-2">
                  <img src="/assets/images/searchic.svg" alt="" />
                  <span className="text-textWhite font-medium">Search</span>
                </button>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeHero;
